import * as React from "react";
const UNINITIALIZED = {};
function useLazyRef(init, initArg) {
  const ref = React.useRef(UNINITIALIZED);
  if (ref.current === UNINITIALIZED) {
    ref.current = init(initArg);
  }
  return ref;
}
export {
  useLazyRef as default
};
//# sourceMappingURL=useLazyRef.es.js.map
